import { render, staticRenderFns } from "./Black808.vue?vue&type=template&id=72d5ed69"
import script from "./Black808.vue?vue&type=script&lang=js"
export * from "./Black808.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports